export const rotatingTexts = [
  "Job Search",
  "Recruitment",
  "Hiring",
  "Talent Acquisition",
  "Candidate Sourcing",
];

export const badgeTexts = [
  "500+ Active Users",
  "1000+ Jobs Posted",
  "50+ Companies",
  "99% Success Rate",
];

export const heroContent = {
  badge: {
    text: "New Features Added Daily",
  },
  heading: {
    prefix: "Streamline Your",
    suffix: "Process",
  },
  description:
    "Collect, organize, and manage candidate profiles from multiple platforms with ease while reducing manual effort.",
  buttons: {
    primary: {
      text: "Start Free Trial",
    },
    secondary: {
      text: "Watch Demo",
    },
  },
  image: {
    alt: "Jobsscribe Dashboard",
  },
};
